<template>
  <v-autocomplete
    v-if="isElemTypeofObject"
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    item-text="text"
    item-value="value"
    return-object
    hide-details
    hide-selected
    browser-autocomplete="nope"
    no-filter
    no-data-text="Данные не выбраны"
    multiple
    chips
    deletable-chips
    small-chips
    clearable
    outline
    :height="selected.length > 2 ? 'auto' : 44"
    class="autofill-chip-small icon-placement"
    @change="handleChange"
  />
  <v-autocomplete
    v-else
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    hide-details
    hide-selected
    browser-autocomplete="nope"
    no-filter
    no-data-text="Данные не выбраны"
    multiple
    chips
    deletable-chips
    small-chips
    clearable
    outline
    :height="selected.length > 2 ? 'auto' : 44"
    class="autofill-chip-small icon-placement"
    @change="handleChange"
  />
</template>

<script>
export default {
  props: ["value", "elements", "label", "filterName", "isElemTypeofObject"],
  data() {
    return {
      selected: [],
      search: null,
      itemsWithoutSelected: [],
    };
  },
  computed: {
    items: {
      set(value) {
        this.itemsWithoutSelected = value;
      },
      get() {
        return [...this.itemsWithoutSelected, ...this.selected];
      },
    },
  },
  watch: {
    search() {
      const elems = this.setItems();
      if (!this.search) {
        this.items = elems;
        return;
      }
      this.items = elems.filter(e => {
        if (this.isElemTypeofObject) {
          return e.text.toUpperCase().includes(this.search.toUpperCase());
        } else {
          return e.toUpperCase().includes(this.search.toUpperCase());
        }
      });
    },
    value: {
      handler(val) {
        if (!val.length) {
          this.search = null;
          this.selected = [];
          return;
        } else {
          this.selected = this.isElemTypeofObject
            ? val.map(s => {
              return {
                value: s.id,
                text: s.title,
              };
            })
            : [...new Set(val)];
        }
      },
      immediate: true,
    },
  },
  created() {
    this.items = this.setItems();
  },
  methods: {
    setItems() {
      let items = [];
      if (this.isElemTypeofObject) {
        items = this.elements.map(e => {
          return {
            value: e.id,
            text: e.title,
          };
        });
      } else {
        items = [...new Set(this.elements)];
      }
      return items;
    },
    handleChange() {
      this.search = "";
      if (this.selected.length > 0) {
        this.$emit("change", {
          prop: this.filterName,
          item: this.isElemTypeofObject
            ? this.selected.map(s => {
              return {
                id: s.value,
                title: s.text,
              };
            })
            : [...new Set(this.selected)],
        });
      } else {
        this.$emit("change", { prop: this.filterName, item: [] });
      }
    },
  },
};
</script>
